var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space-y-6"},_vm._l((_vm.data),function(value,prop){return _c('div',{key:prop},[_c('CanvasSectionRow',{attrs:{"hasBg":false},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var blockClasses = ref.blockClasses;
return [_c('div',{class:blockClasses,style:({
          maxWidth: value
        })})]}}],null,true)}),_c('CanvasBlockLabel',{attrs:{"label":("" + prop + (_vm.config.separator)),"value":value}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }